import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { SortSettings } from "@@/shared/sortSettings";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import type { ProductReference } from "../products/product";
import type { SectionTheme } from "./themes/section-theme";

type SectionId = string;
type Section = {
    _id: SectionId;
    _type: "SECTION";
    _createdAt: IsoAndUnixTimestamp;
    sectionTheme: SectionTheme;
    meta: MetaContent;
    items: ProductReference[];
    ownerId: string | undefined;
    sorting: SortSettings;
};
const createSectionId = (): SectionId => generateId({ prefix: "section__" });
const createSection = (
    params: Except<Section, "_id" | "_type" | "_createdAt"> & {
        _id?: string;
        sortNumber?: number;
    },
): Section => {
    return {
        ...params,
        _id: params._id || createSectionId(),
        _type: "SECTION",
        _createdAt: nowIsoAndUnix(),
    };
};

export { createSection, createSectionId };
export type { Section, SectionId };
